// extracted by mini-css-extract-plugin
export default {"SponsorCarousel":"SponsorCarousel-module--SponsorCarousel--UbfYg","Back":"SponsorCarousel-module--Back--vjFwQ","Next":"SponsorCarousel-module--Next--ZDs0m"};